import { useContext } from 'react';
import { TenantContext } from '@/contexts/TenantContext';
import { TenantContextValue } from '@/types/tenant';

/**
 * Hook to access tenant information from context
 */
export function useTenant(): TenantContextValue {
  const context = useContext(TenantContext);
  
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  
  return context;
}

/**
 * Hook to get just the provider information
 */
export function useProvider() {
  const { provider } = useTenant();
  return provider;
}

/**
 * Hook to get branding information
 */
export function useBranding() {
  const { branding } = useTenant();
  return branding;
}

/**
 * Hook to check if current domain is a custom domain
 */
export function useIsCustomDomain() {
  const { isCustomDomain } = useTenant();
  return isCustomDomain;
}